"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _auto = require("chart.js/auto");
var _reactChartjs = require("react-chartjs-2");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//Radar Chart Implementation
function BarGraph(props) {
  const Labels = props.data.map(lan => lan.label);
  const dataVal = props.data.map(val => val.value);
  const graphData = {
    labels: Labels,
    datasets: [{
      label: 'Data',
      backgroundColor: "#D2E2F0",
      borderColor: '#1F70B7',
      data: dataVal,
      fill: true
    }]
  };
  const graphOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: {
        scaleLabel: {
          display: true
        },
        ticks: {
          beginAtZero: true
        }
      }
    }
  };
  return (
    /*#__PURE__*/
    // <div  style={props.backstyle}>
    _react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactChartjs.Radar, {
      data: graphData,
      options: graphOptions
    }))
  );
}
var _default = exports.default = BarGraph;